import React from 'react';

import { GetSurveyForClientDto } from '../../../common/pokCore/autogenerated/pokApiClient';

import { AnswerValues, PublicSurveyState } from './PublicSurveyContainer';
import { PublicSurveyProgress } from './PublicSurveyProgress';
import { PublicSurveyQuestion } from './PublicSurveyQuestion';
import { PublicSurveyNavigation } from './PublicSurveyNavigation';

interface PublicSurveyQuestionsViewProps {
  survey: GetSurveyForClientDto;
  state: PublicSurveyState;
  error: string;
  direction: 'left' | 'right';
  currentLanguage: string;
  isBlocked: boolean;
  isPreview?: boolean;
  getCurrentAnswer: () => AnswerValues;
  handleAnswerChange: (value: AnswerValues) => void;
  handleBack: () => void;
  handleNext: () => void;
  handleFinishBlocked: () => void;
}

export const PublicSurveyQuestionsView: React.FC<
  PublicSurveyQuestionsViewProps
> = ({
  survey,
  state,
  error,
  direction,
  currentLanguage,
  isBlocked,
  isPreview = false,
  getCurrentAnswer,
  handleAnswerChange,
  handleBack,
  handleNext,
  handleFinishBlocked,
}) => {
  const currentQuestion = survey.questions[state.currentQuestionIndex];

  return (
    <div
      className={`public-survey-hero-bg ${isPreview ? 'public-survey-hero-bg--preview' : ''} d-flex flex-column p-3 p-sm-4 p-lg-5`}
    >
      <div className="position-relative d-flex flex-column flex-grow-1 public-survey-container mx-auto w-100">
        <PublicSurveyProgress
          current={state.currentQuestionIndex}
          total={survey.questions.length}
          currentLanguage={currentLanguage}
        />
        <div className="flex-grow-1 d-flex align-items-center justify-content-center py-4">
          <div className="w-100 public-survey-glass public-survey-shadow public-survey-question-card">
            <PublicSurveyQuestion
              question={currentQuestion}
              language={currentLanguage}
              value={getCurrentAnswer()}
              onChange={handleAnswerChange}
              error={error}
              direction={direction}
            />
            <PublicSurveyNavigation
              onBack={handleBack}
              onNext={handleNext}
              onFinishBlocked={handleFinishBlocked}
              canGoBack={state.currentQuestionIndex > 0}
              isLastQuestion={
                state.currentQuestionIndex === survey.questions.length - 1
              }
              isBlocked={isBlocked}
              currentLanguage={currentLanguage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
